import Vue from 'vue'
import Vuex from 'vuex'
import permission from './modules/permission'
import user from './modules/user'
import layout from './modules/layout'
import getters from './getters'
import trainingKit from './modules/trainingKit'
import classTable from './modules/classTable'
import release from './modules/release'
import classDetail from './modules/classDetail'
import system from './modules/system'
import classTool from './modules/classTool'
import cancle from './modules/cancle'
import message from './modules/message'
import processTraining from './modules/processTraining'
import classSchedule from './modules/classSchedule'


//修改者inner---im存放数据 
import imBus from './modules/imBus'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    permission,
    user,
    layout,
    trainingKit,
    classTable,
    release,
    classDetail,
    classTool,
    system,
    cancle,
    message,
    processTraining,
    imBus,
    classSchedule
  },
  getters
})

export default store
